import { render, staticRenderFns } from "./RegisteredDataComponentMultiple.vue?vue&type=template&id=2bccfe72&scoped=true"
import script from "./RegisteredDataComponentMultiple.vue?vue&type=script&lang=js"
export * from "./RegisteredDataComponentMultiple.vue?vue&type=script&lang=js"
import style0 from "./RegisteredDataComponentMultiple.vue?vue&type=style&index=0&id=2bccfe72&prod&lang=less"
import style1 from "./RegisteredDataComponentMultiple.vue?vue&type=style&index=1&id=2bccfe72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bccfe72",
  null
  
)

export default component.exports